// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { documentTemplateId } from './DocumentTemplate';
import { operatorId } from './Operator';
import { z } from 'zod';
export const documentTemplateVersionId = (z.number());
export const documentTemplateVersion = z.object({
    id: documentTemplateVersionId,
    template_id: documentTemplateId,
    version_number: z.number(),
    content: z.string(),
    requires_resign: z.boolean(),
    created_at: z.date().nullable(),
    created_by: operatorId.nullable(),
});
export const documentTemplateVersionInitializer = z.object({
    id: documentTemplateVersionId.optional(),
    template_id: documentTemplateId,
    version_number: z.number(),
    content: z.string(),
    requires_resign: z.boolean().optional(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
});
export const documentTemplateVersionMutator = z.object({
    id: documentTemplateVersionId.optional(),
    template_id: documentTemplateId.optional(),
    version_number: z.number().optional(),
    content: z.string().optional(),
    requires_resign: z.boolean().optional(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DocumentTemplateVersion.js.map